import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=2972768b&"
import script from "./SplashScreen.vue?vue&type=script&lang=js&"
export * from "./SplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports